import { render, staticRenderFns } from "./TalksTable.vue?vue&type=template&id=4470fb29"
import script from "./TalksTable.vue?vue&type=script&lang=js"
export * from "./TalksTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports